import React from 'react';

const SVGWrapper = ({ src, color, gradient, width = 24, height = 24, className = '' }) => {
  const svgUrl = `${process.env.PUBLIC_URL || ''}${src}`;

  return (
    <div
      className={className}
      style={{
        width,
        height,
        maskImage: `url(${svgUrl})`,
        WebkitMaskImage: `url(${svgUrl})`,
        background: gradient || color,
        maskRepeat: 'no-repeat',
        WebkitMaskRepeat: 'no-repeat',
        maskSize: 'contain',
        WebkitMaskSize: 'contain',
      }}
    />
  );
};

export default SVGWrapper;